import { OrderItem, OrderItemResponse } from "@/types/order-type";


export function calculateOrderTotals({
    items,
    deliveryFee = 0,
    discountPercentage = 0,
    taxRate = 0.1,              // default = 10%
}: {
    items: OrderItemResponse[] | OrderItem[];
    deliveryFee?: number;
    discountPercentage?: number;
    taxRate?: number;
}) {
    const subtotal = items.reduce(
        (sum, it) => sum + Number(it.price) * it.quantity,
        0
    );
    const totalItems = items.reduce(
        (sum, it) => sum + it.quantity,
        0
    );

    const discount = discountPercentage; // If you later want percentage %, adjust here

    const taxableAmount = subtotal + deliveryFee - discount;

    const tax = taxableAmount * taxRate;

    const total = subtotal + deliveryFee - discount + tax;

    return {
        subtotal,
        shippingFee: deliveryFee,
        discount,
        tax,
        total,
        totalItems,
    };
}